<template>
  <div class="data-list">
    <div class="data-list-header">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">进行中活动</div>
            <div class="number">{{ panelData.inProgress }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">已结束活动</div>
            <div class="number">{{ panelData.end }}</div>
          </el-card>
        </el-col>

        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">参与经销商</div>
            <div class="number">{{ panelData.joinCustomer }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">参与职员</div>
            <div class="number">{{ panelData.joinStaff }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">拉新人数</div>
            <div class="number">{{ panelData.pullNew }}</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">参与人数</div>
            <div class="number">{{ panelData.joinNum }}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="120px" size="mini">
            <el-form-item label="区域筛选" prop="parentIdCode">
              <el-select v-model="searchForm.parentIdCode" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="item in officeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经销商编码" prop="code">
              <el-input class="form-input" v-model="searchForm.code" clearable placeholder="请输入编码"></el-input>
            </el-form-item>
            <el-form-item label="经销商名称" prop="name">
              <el-input class="form-input" v-model="searchForm.name"  clearable placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item label="截止时间" prop="updatedTime">
              <q-date-picker v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleAdd(null, 1)">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          @sort-change="handleSortChange"
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="code" label="经销商编码" align="center" width="120"></el-table-column>
          <el-table-column prop="name" label="经销商名称" show-overflow-tooltip align="center" width="300"></el-table-column>
          <el-table-column prop="shop" label="门店数" align="center" min-width="120"></el-table-column>
          <el-table-column prop="createNum" label="活动创建数" sortable="custom" align="center" min-width="120"></el-table-column>
          <el-table-column prop="activityJoinNum" label="参与活动数" sortable="custom" align="center" min-width="120"></el-table-column>
          <el-table-column prop="pullNew" label="用户拉新数" sortable="custom" align="center" min-width="120"></el-table-column>
          <el-table-column prop="joinNum" label="用户参与数" sortable="custom" align="center" min-width="120"></el-table-column>
          <el-table-column prop="sales" label="销售额" sortable="custom" align="center" min-width="120"></el-table-column>
          <el-table-column prop="smsNum" label="短信数" align="center" min-width="120"></el-table-column>
          <el-table-column prop="smsSplitNum" label="拆份数" align="center" min-width="120"></el-table-column>
          <el-table-column prop="closingRate" label="报名成功率" align="center" min-width="120"></el-table-column>
          <el-table-column label="操作" class-name="action-column" align="center" fixed="right" width="90">
            <template v-slot="scope">
              <el-button type="text" size="small" @click="handleAdd(scope.row, 3)"> 查看详情 </el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "dealerList",
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
      searchForm: {
        code: "",
        name: "",
        parentIdCode: "",
        startTime: '',
        endTime: ''
      },
      panelData: {},

      // 表格相关
      tableData: [],
      selection: [],
      officeList: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
      sortForm: {},
      queryType: [5,1,2,4,3],
      querySortType: ['sales','createNum','activityJoinNum','joinNum','pullNew'],
      lastQuery: {}
    };
  },
  methods: {
    init() {
      this.getOrgBoardInfo();
      this.onSearch();
      this.getOrgList();
    },
    getOrgBoardInfo() {
      this.$api.dataReport.orgBoardInfo().then((res) => {
        this.panelData = res.data;
      });
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
          ...this.sortForm,
        },
      };
      this.$api.dataReport
        .cusDateReportPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.initDate()
      this.onSearch();
    },
    onSearch() {
      this.$nextTick(_=>{
        this.$refs.tableRef.clearSort()
      })
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    getOrgList() {
      this.$api.home.getOrgList().then((res) => {
        this.officeList = res.data;
      });
    },
    handleSortChange({ column, prop, order }) {
      let labelType = {
        活动创建数: 1,
        参与活动数: 2,
        用户拉新数: 3,
        用户参与数: 4,
        销售额: 5,
      };
      this.sortForm = {
        sortType: labelType[column.label],
        sortord: order == "ascending" ? 1 : order === "descending" ? 2 : "",
      };
      this.getList();
    },
    handleAdd(row, actionType) {
      this.actionType = actionType;
      this.modifyData = row || null;
      this.isShowAdd = true;

      if (actionType == 3) {
        this.openSubPage({
          path: "/dataReport/store",
          query: {
            code: row.id,
            cusName: row.name,
            updatedTime: this.searchForm.updatedTime,
          },
        });
      } else if (actionType == 1) {
        let params = {
          ...this.filterParam,
        };
        this.$api.common.doExport("cusDateReportPageList", params).then(() => {
          this.$message.success("导出操作成功，请前往导出记录查看详情");
        });
      }
    },
    isArrayEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    },
    initDate(query = {}) {
      if (query.updatedTime && query.updatedTime.length) {
        this.searchForm.startTime = query.updatedTime[0]
        this.searchForm.endTime = query.updatedTime[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
        this.$refs.dateRef.reset()
      }
    }
  },
  watch: {
    '$route.query': {
      handler(val, olv) {
        if (
          this.$route.name == 'dealerList' &&
          JSON.stringify(val) != "{}" &&
          (val.parentIdCode != this.lastQuery.parentIdCode || (val.type && this.queryType[val.type - 1] != this.sortForm.sortType) || !this.isArrayEqual(val.updatedTime || [], this.lastQuery.updatedTime || []))
        ) {
          this.lastQuery = {...val}
          this.searchForm.parentIdCode = val.parentIdCode || "";
          this.initDate(val)
          //工作台跳转该页面 带入指标筛选选中的默认降序
          if(val.type) {
            this.sortForm = {
              sortType: this.queryType[val.type - 1],
              sortord: 2
            } 
            setTimeout( () => {
              this.$nextTick(() => {
                this.$refs.tableRef.sort(this.querySortType[val.type - 1], 'descending')
              })
            },500)
          }
          this.init();
        }
      },
    },
  },
  mounted() {
    let query = this.$route.query;
    this.lastQuery = query
    this.searchForm.parentIdCode = query.parentIdCode || "";
    this.initDate(query)
    //工作台跳转该页面 带入指标筛选选中的默认降序
    if(query.type) {
      this.sortForm = {
        sortType: this.queryType[query.type - 1],
        sortord: 2
      } 
      setTimeout( () => {
        this.$nextTick(() => {
          this.$refs.tableRef.sort(this.querySortType[query.type - 1], 'descending')
        })
      },500)
    }
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  .date-input {
    width 220px !important
  }
  .data-list-header {
    margin: 6px 16px;
    .header {
      color: #ccc;
      text-align: center;
      padding: 6px 0;
      border-bottom: 1px solid #ccc;
    }
    .number {
        text-align: center;
        padding: 6px 0;
    }
  }
}
</style>
